import { ColumnType, Row } from "@asayinc/component-library";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";

import { INoboEvent } from "src/store/noboEvent/types";

dayjs.extend(relativeTime);
dayjs.extend(utc);

export const NOBO_EVENTS_COLUMNS = [
  "recordDate",
  "solicitor",
  "scheduled",
  "delivered",
  "created",
];

export type ColumnDataHelpers = {
  getSort: (sortKey: string) => "asc" | "desc" | undefined;
  onOrderingChange: (data: unknown, sortKey: string) => void;
};

export type NoboEventsColumnData = {
  jobNumber: ColumnType;
  issuer: ColumnType;
  recordDate: ColumnType;
  solicitor: ColumnType;
  scheduled: ColumnType;
  delivered: ColumnType;
  created: ColumnType;
};

export function getColumnData({
  getSort,
  onOrderingChange,
}: ColumnDataHelpers): NoboEventsColumnData {
  return {
    issuer: {
      sort: getSort("issuer__name"),
      sortFn: (data: unknown) => onOrderingChange(data, "issuer__name"),
      style: "text",
      title: "Issuer",
    },
    recordDate: {
      sort: getSort("record_date"),
      sortFn: (data: unknown) => onOrderingChange(data, "record_date"),
      style: "text",
      title: "Record Date",
    },
    solicitor: {
      sort: getSort("solicitor__name"),
      sortFn: (data: unknown) => onOrderingChange(data, "solicitor__name"),
      style: "text",
      title: "Solicitor",
    },
    created: {
      sort: getSort("created"),
      sortFn: (data: unknown) => onOrderingChange(data, "created"),
      style: "text",
      title: "Created",
    },
    jobNumber: {
      sort: getSort("job_number"),
      sortFn: (data: unknown) => onOrderingChange(data, "job_number"),
      style: "text",
      title: "Job Number",
    },
    scheduled: {
      sort: getSort("scheduled"),
      sortFn: (data: unknown) => onOrderingChange(data, "scheduled"),
      style: "text",
      title: "Scheduled",
    },
    delivered: {
      sort: getSort("delivered"),
      sortFn: (data: unknown) => onOrderingChange(data, "delivered"),
      style: "text",
      title: "Delivered",
    },
  };
}

export function getRowData(
  events: INoboEvent[],
  onRowClick: (event: INoboEvent) => void
): Row[] {
  const handleRowClick = (data: unknown) => {
    const { event } = data as {
      event: INoboEvent;
      idx: string;
    };
    onRowClick(event);
  };

  return events.map((event, idx) => {
    const {
      id,
      issuer,
      recordDate,
      solicitor,
      jobNumber,
      scheduledGenerationAt,
      generatedAt,
      created,
    } = event;

    return {
      id,
      data: { event, idx },
      rowData: {
        issuer: {
          content: issuer.name,
          clickHandler: handleRowClick,
        },
        recordDate: {
          content: dayjs(recordDate).format("MM/DD/YYYY"),
          clickHandler: handleRowClick,
        },
        solicitor: {
          content: solicitor.name,
          clickHandler: handleRowClick,
        },
        created: {
          content: dayjs(created).format("MM/DD/YYYY"),
          clickHandler: handleRowClick,
        },
        jobNumber: {
          content: jobNumber || "-",
          clickHandler: handleRowClick,
        },
        scheduled: {
          content: scheduledGenerationAt
            ? dayjs(scheduledGenerationAt).format("MM/DD/YYYY")
            : "",
          clickHandler: handleRowClick,
        },
        delivered: {
          content: generatedAt ? dayjs(generatedAt).format("MM/DD/YYYY") : "",
          clickHandler: handleRowClick,
        },
      },
    };
  });
}
